import getAxiosInstance from '../../../../../helpers/get_axios_instance'
import lrsAdapter from '../../../../../helpers/lrs_adapter'

export class TablaMovimientoMercaderiaService {
  static async getMovimientosMercaderiaPendientes () {
    const axios = getAxiosInstance()
    return axios.get('/movimiento_mercaderia_en_toneladas_pendiente')
      .then(lrsAdapter, lrsAdapter)
      .then(result => result.data)
  }

  static async updateTareaMovimientoMercaderia (fechaRegistroTarea, tarea, fInicio) {
    const axios = getAxiosInstance()
    const promise = axios.put(`movimiento_mercaderia_en_toneladas`,
      `{"valores": {"tarea": "${tarea}", "fecha_de_inicio": "${fInicio}"},
    "clave":{"fecha_registro_tarea": "${fechaRegistroTarea}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
  }

  static async finalizarTareaMovimientoMercaderia (fechaRegistroTarea, tarea, fInicio, fFin, toneladas) {
    const axios = getAxiosInstance()
    const promise = axios.put(`movimiento_mercaderia_en_toneladas_pendiente`,
      `{"valores": {"tarea": "${tarea}", "fecha_de_inicio": "${fInicio}", "fecha_de_finalizacion": "${fFin}", "toneladas": "${toneladas}"},
    "clave":{"fecha_registro_tarea": "${fechaRegistroTarea}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
  }
}
